// components/PhoneUtils.js

/**
 * Fonction pour formater un numéro de téléphone français.
 * @param {string} phoneNumber - Le numéro de téléphone à formater.
 * @returns {string} - Le numéro de téléphone formaté.
 */
const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';

  // Supprimer tous les caractères non numériques
  let normalizedNumber = phoneNumber.replace(/\D/g, '');

  // Vérifier que le numéro commence par 33, 0033 ou +33 et le convertir en 0
  if (normalizedNumber.startsWith('33')) {
    normalizedNumber = '0' + normalizedNumber.substring(2); // Remplacer le code du pays "33" par "0"
  } else if (normalizedNumber.startsWith('0033')) {
    normalizedNumber = '0' + normalizedNumber.substring(4); // Remplacer "0033" par "0"
  }

  // Ajouter des espaces toutes les 2 positions après le premier chiffre
  normalizedNumber = normalizedNumber.replace(/(\d{2})(?=\d)/g, '$1 ');

  return normalizedNumber;
};


export default formatPhoneNumber;